import { LinkAuthMethodOut } from '../ports/out/LinkAuthMethodOut';

export class LinkAuthMethodService {
    public constructor(private linkAuthMethodOut: LinkAuthMethodOut) {
    }

    public async linkAuthMethod(
        authMethod: string,
        credentials: object,
        isBigReward: boolean = true
    ): Promise<true|Error> {
        const linkResult = this.linkAuthMethodOut.linkAuthMethod(authMethod, credentials, isBigReward);
        // @ts-ignore
        return linkResult;
    }
}
